import { Typography } from '@telavita-core/react-design-kit'
import styled from 'styled-components'

interface IContainerProps {
  fontSize: 'sm' | 'md';
  gap: string;
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap};

  p {
    font-size: ${({ fontSize }) => (fontSize === 'sm' ? '13px' : '15px')};
  }
`

export const CustomTypography = styled(Typography)`
  span {
    font-weight: bold;
    color: #fcbc55;
  }

  a {
    color: #1f35b5;
  }
`

export const ButtonsWrapper = styled.div`
  margin-bottom: 20px;
  button {
    width: 100%;
  }

  button + button {
    margin-top: 20px;
  }
`
